import { URLS } from '@/utils/urls'
import { isNullOrUndefined } from '@/utils'
import Vue from 'vue'
import store from '@/store'

export const extractLoginRedirect = (error) => (error.response && error.response.data && error.response.data.NeedRedirect) ? error.response.data.RedirectUrl: undefined
export const extractUserId = (currentUser) => currentUser.Id
export const extractUserAbilities = (currentUser) => currentUser.UserAbilities
export const extractUserLocale = (currentUser) => currentUser.Locale
export const extractUserLanguage = (currentUser) => currentUser.Language
export const extractUserStartPage = (currentUser) => (currentUser.HomePage && currentUser.HomePage.Id > 0) ? `${URLS.GWT.Workspace(currentUser.HomePage.Id)}` : `${URLS.App.Home()}`

export const extractTheme = (currentUser) => {
  const theme = currentUser.Theme
  if (isNullOrUndefined(theme) || (theme === '')) {
    return 'default'
  } else if (theme.startsWith('Gray')) {
    return 'hubble-theme-' + currentUser.Theme.substring(4).toLowerCase()
  }
  return theme.toLowerCase()
}

/**
 * API Error Response Schemas
 * - Login API: `{ response: { data: { LoginErrors: ['message 1', 'message 2'] } }}`
 * - Logout API: `{ response: { data: { Message: 'message' } }}`
 * - Workspace API: `{ response: { data: { Message: 'message' } }}`
 */
export const extractErrors = {
  login: (error) => (error.response && error.response.data && Array.isArray(error.response.data.LoginErrors)) ? error.response.data.LoginErrors : undefined,
  logout: (error) => (error.response && error.response.data) ? [ error.response.data.Message ] : undefined,
  workspace: (error) => (error.response && error.response.data) ? [ error.response.data.Message ] : undefined
}

export default {
  extractTheme,
  extractErrors,
  extractLoginRedirect,
  extractUserId,
  extractUserAbilities,
  extractUserStartPage,
  extractUserLanguage,
  extractUserLocale
}
